import { Reveal } from "@/components/Reveal";

const OFFERINGS = [
  {
    n: "01",
    title: "Shaped entirely around you",
    body: "Every session is designed for your body, your energy and your goals — whether that's building strength, finding stillness, or simply moving more kindly.",
  },
  {
    n: "02",
    title: "In the comfort of your home",
    body: "I travel to you, anywhere in Bath. No studio, no commute, no audience — just a familiar room and an hour that belongs to you.",
  },
  {
    n: "03",
    title: "Everything is provided",
    body: "Mats, blocks, blankets and bolsters all come with me. All you need is a small clear space and an open morning or evening.",
  },
];

export const Practice = () => (
  <section id="practice" data-testid="practice-section" className="py-28 md:py-40 bg-cream-deep">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <Reveal>
        <p className="uppercase text-xs sm:text-sm tracking-[0.28em] font-medium text-terracotta" data-testid="practice-overline">
          The Practice
        </p>
        <h2 className="font-serif font-light text-4xl sm:text-5xl tracking-tight leading-tight mt-5 max-w-2xl" data-testid="practice-heading">
          Private yoga that comes to you
        </h2>
      </Reveal>

      <div className="mt-20 md:mt-28 space-y-0">
        {OFFERINGS.map((o, i) => (
          <Reveal key={o.n} delay={i * 0.12}>
            <div
              className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-8 py-10 md:py-14 border-t border-olive/10"
              data-testid={`offering-${o.n}`}
            >
              <span className="md:col-span-2 font-serif italic text-2xl text-sage">{o.n}</span>
              <h3 className="md:col-span-4 font-serif font-normal text-2xl sm:text-3xl leading-snug" data-testid={`offering-title-${o.n}`}>
                {o.title}
              </h3>
              <p className="md:col-span-5 md:col-start-8 text-base leading-relaxed font-light tracking-wide text-olive-soft" data-testid={`offering-body-${o.n}`}>
                {o.body}
              </p>
            </div>
          </Reveal>
        ))}
      </div>

      <div id="pricing" className="mt-24 md:mt-32 grid grid-cols-1 md:grid-cols-12 gap-8 items-end">
        <Reveal className="md:col-span-5">
          <p className="uppercase text-xs sm:text-sm tracking-[0.28em] font-medium text-terracotta" data-testid="pricing-overline">
            Pricing
          </p>
          <div className="mt-6 flex items-baseline gap-4">
            <span className="font-serif font-light text-7xl sm:text-8xl tracking-tighter text-olive" data-testid="pricing-amount">
              £60
            </span>
            <span className="font-serif italic text-2xl text-sage" data-testid="pricing-unit">per hour</span>
          </div>
        </Reveal>
        <Reveal delay={0.15} className="md:col-span-6 md:col-start-7">
          <p className="text-base sm:text-lg leading-relaxed font-light tracking-wide text-olive-soft" data-testid="pricing-note">
            One simple rate, with travel within Bath and all equipment included.
            Sessions usually run for an hour — longer sessions and small groups
            of two can be arranged on request.
          </p>
        </Reveal>
      </div>
    </div>
  </section>
);
